import { TokenInfo } from "@labb/constellation-core-types";

const DEV_TOKEN_STORAGE_KEY = "pega_dev_token";
const DEFAULT_EXPIRES_IN = 3600;

function toTokenInfo(accessToken: string, expiresIn: number): TokenInfo {
  return {
    access_token: accessToken,
    token_type: "Bearer",
    expires_in: expiresIn,
  };
}

function parseStoredToken(raw: string): TokenInfo | null {
  try {
    const parsed = JSON.parse(raw) as TokenInfo;
    if (typeof parsed.access_token === "string") {
      return {
        access_token: parsed.access_token,
        token_type: parsed.token_type ?? "Bearer",
        expires_in: parsed.expires_in ?? DEFAULT_EXPIRES_IN,
      };
    }
  } catch {
    // Not JSON — treat as bare access token string
  }

  if (raw.trim()) {
    return toTokenInfo(raw.trim(), DEFAULT_EXPIRES_IN);
  }

  return null;
}

export function readDevPegaToken(): TokenInfo | null {
  if (!import.meta.env.DEV) {
    return null;
  }

  const query = new URLSearchParams(window.location.search);
  const urlToken = query.get("pegaToken");
  if (urlToken) {
    const expiresIn = Number(query.get("pegaTokenExpiresIn")) || DEFAULT_EXPIRES_IN;
    return toTokenInfo(urlToken, expiresIn);
  }

  const stored = localStorage.getItem(DEV_TOKEN_STORAGE_KEY);
  if (stored) {
    return parseStoredToken(stored);
  }

  return null;
}
